import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "../../../utills/api";

const formatCurrency = (amount) => {
  return Number(amount || 0).toLocaleString("en-IN");
};

const InvoiceDownload = async (viewData) => {
  try {
    // ==========================================
    // FETCH HOTEL DETAILS FROM LOGIN API
    // ==========================================

    let hotelData = {};

    try {
      const hotelRes = await axios.get("/auth/login");

      hotelData = hotelRes?.data || {};
    } catch (err) {
      console.log("Hotel data fetch failed");
    }

    // ==========================================
    // CALCULATIONS
    // ==========================================

    const totalFood =
      viewData.services?.foodOrders?.reduce(
        (sum, f) =>
          sum +
          (Number(f.finalAmount || 0) - Number(f.discount || 0)),
        0
      ) || 0;

    const totalSpa =
      viewData.services?.spaOrders?.reduce(
        (sum, s) =>
          sum + (Number(s.price || 0) - Number(s.discount || 0)),
        0
      ) || 0;

    const totalWellness =
      viewData.services?.wellnessOrders?.reduce(
        (sum, w) =>
          sum + (Number(w.price || 0) - Number(w.discount || 0)),
        0
      ) || 0;

    const totalTaxi =
      viewData.services?.taxiOrders?.reduce(
        (sum, t) => sum + Number(t.price || 0),
        0
      ) || 0;

    const roomAmount = Number(
      viewData.originalBookingAmount ||
        viewData.charges?.booking ||
        0
    );

    const extensionAmount = Number(
      viewData.extensionAmount || 0
    );

    const grandTotal =
      roomAmount +
      extensionAmount +
      totalFood +
      totalSpa +
      totalWellness +
      totalTaxi;

    // ==========================================
    // CREATE ROWS
    // ==========================================

    const rows = [];

    let sr = 1;

    if (roomAmount > 0) {
      rows.push(`
        <tr>
          <td class="td-center">${sr++}</td>
          <td>Room Booking Charges</td>
          <td class="td-right">₹ ${formatCurrency(roomAmount)}</td>
          <td class="td-right">₹ ${formatCurrency(roomAmount)}</td>
        </tr>
      `);
    }

    if (extensionAmount > 0) {
      rows.push(`
        <tr>
          <td class="td-center">${sr++}</td>
          <td>Extension Charges</td>
          <td class="td-right">₹ ${formatCurrency(extensionAmount)}</td>
          <td class="td-right">₹ ${formatCurrency(extensionAmount)}</td>
        </tr>
      `);
    }

    if (totalFood > 0) {
      rows.push(`
        <tr>
          <td class="td-center">${sr++}</td>
          <td>Food Services</td>
          <td class="td-right">₹ ${formatCurrency(totalFood)}</td>
          <td class="td-right">₹ ${formatCurrency(totalFood)}</td>
        </tr>
      `);
    }

    if (totalSpa > 0) {
      rows.push(`
        <tr>
          <td class="td-center">${sr++}</td>
          <td>Spa Services</td>
          <td class="td-right">₹ ${formatCurrency(totalSpa)}</td>
          <td class="td-right">₹ ${formatCurrency(totalSpa)}</td>
        </tr>
      `);
    }

    if (totalWellness > 0) {
      rows.push(`
        <tr>
          <td class="td-center">${sr++}</td>
          <td>Wellness Services</td>
          <td class="td-right">₹ ${formatCurrency(totalWellness)}</td>
          <td class="td-right">₹ ${formatCurrency(totalWellness)}</td>
        </tr>
      `);
    }

    if (totalTaxi > 0) {
      rows.push(`
        <tr>
          <td class="td-center">${sr++}</td>
          <td>Taxi Services</td>
          <td class="td-right">₹ ${formatCurrency(totalTaxi)}</td>
          <td class="td-right">₹ ${formatCurrency(totalTaxi)}</td>
        </tr>
      `);
    }

    // ==========================================
    // CREATE A4 INVOICE
    // ==========================================

    const invoice = document.createElement("div");

    invoice.style.width = "794px";
    invoice.style.minHeight = "1123px";
    invoice.style.background = "#fff";
    invoice.style.padding = "20px";
    invoice.style.position = "absolute";
    invoice.style.left = "-9999px";

    invoice.innerHTML = `
      <div
        style="
          width:100%;
          min-height:1080px;
          border:3px solid #8c8c8c;
          color:#8c8c8c;
          font-family:Arial;
          padding:20px;
          box-sizing:border-box;
        "
      >

        <!-- HEADER -->

        <div
          style="
            display:flex;
            justify-content:space-between;
            align-items:flex-start;
            border-bottom:2px solid #8c8c8c;
            padding-bottom:15px;
          "
        >

          <div>
            <div
              style="
                font-size:44px;
                font-weight:bold;
                line-height:45px;
              "
            >
              ${hotelData?.name || "YatraNest"}
            </div>

            <div
              style="
                margin-top:8px;
                font-size:14px;
              "
            >
              Tenant ID :
              ${hotelData?.tenantId || "-"}
            </div>

            <div
              style="
                margin-top:5px;
                font-size:14px;
              "
            >
              Email :
              ${hotelData?.email || "-"}
            </div>
          </div>

          <div
            style="
              text-align:right;
            "
          >
            <div
              style="
                font-size:30px;
                font-weight:bold;
              "
            >
              INVOICE
            </div>

            <div style="margin-top:10px;font-size:14px;">
              Invoice Date :
              ${new Date().toLocaleDateString()}
            </div>

            <div style="margin-top:5px;font-size:14px;">
              Booking ID :
              ${viewData.bookingId || "-"}
            </div>
          </div>

        </div>

        <!-- GUEST DETAILS -->

        <div
          style="
            margin-top:25px;
            border:2px solid #8c8c8c;
          "
        >

          <table
            style="
              width:100%;
              border-collapse:collapse;
              font-size:15px;
            "
          >

            <tr>
              <td class="label">Guest Name</td>
              <td class="value">
                ${viewData.name || "-"}
              </td>

              <td class="label">Mobile</td>
              <td class="value">
                ${viewData.mobile || "-"}
              </td>
            </tr>

            <tr>
              <td class="label">Room Number</td>
              <td class="value">
                ${viewData.roomNumber || "-"}
              </td>

              <td class="label">Room Type</td>
              <td class="value">
                ${viewData.roomType || "-"}
              </td>
            </tr>

            <tr>
              <td class="label">Check-In</td>
              <td class="value">
                ${
                  viewData.checkIn
                    ? new Date(
                        viewData.checkIn
                      ).toLocaleString()
                    : "-"
                }
              </td>

              <td class="label">Check-Out</td>
              <td class="value">
                ${
                  viewData.checkOut
                    ? new Date(
                        viewData.checkOut
                      ).toLocaleString()
                    : "-"
                }
              </td>
            </tr>

          </table>

        </div>

        <!-- EXPENSE TABLE -->

        <table
          style="
            width:100%;
            border-collapse:collapse;
            margin-top:25px;
            font-size:15px;
          "
        >

          <thead>

            <tr
              style="
                background:#8c8c8c;
                color:white;
              "
            >

              <th class="th-style">
                S.No
              </th>

              <th class="th-style">
                Particulars
              </th>

              <th class="th-style">
                Rate
              </th>

              <th class="th-style">
                Total Amount
              </th>

            </tr>

          </thead>

          <tbody>

            ${rows.join("")}

            ${
              rows.length < 14
                ? Array(14 - rows.length)
                    .fill(
                      `
                    <tr>
                      <td class="empty-row"></td>
                      <td class="empty-row"></td>
                      <td class="empty-row"></td>
                      <td class="empty-row"></td>
                    </tr>
                  `
                    )
                    .join("")
                : ""
            }

          </tbody>

        </table>

        <!-- TOTAL SECTION -->

        <div
          style="
            margin-top:0;
            border:2px solid #8c8c8c;
            border-top:none;
            display:flex;
          "
        >

          <div
            style="
              width:70%;
              border-right:2px solid #8c8c8c;
              padding:15px;
              min-height:120px;
            "
          >

            <div
              style="
                font-size:16px;
                font-weight:bold;
              "
            >
              Amount In Words
            </div>

            <div
              style="
                margin-top:10px;
                font-size:15px;
                color:#fff;
                background-color: #fff
                
              "
            >
              Rupees
              ${formatCurrency(grandTotal)}
              Only
            </div>

          </div>

          <div
            style="
              width:30%;
            "
          >

            <table
              style="
                width:100%;
                border-collapse:collapse;
                font-size:15px;
              "
            >

              <tr>
                <td class="total-label">
                  Sub Total
                </td>

                <td class="total-value">
                  ₹ ${formatCurrency(grandTotal)}
                </td>
              </tr>

              <tr>
                <td class="total-label">
                  Tax
                </td>

                <td class="total-value">
                  ₹ 0
                </td>
              </tr>

              <tr
                style="
                  background:#8c8c8c;
                  color:white;
                  font-weight:bold;
                "
              >
                <td class="total-label">
                  Grand Total
                </td>

                <td class="total-value">
                  ₹ ${formatCurrency(grandTotal)}
                </td>
              </tr>

            </table>

          </div>

        </div>

        <!-- PAYMENT STATUS -->

        <div
          style="
            margin-top:25px;
            text-align:center;
            font-size:28px;
            color:green;
            font-weight:bold;
          "
        >
          PAYMENT RECEIVED
        </div>

        <!-- FOOTER -->

        <div
          style="
            margin-top:120px;
            display:flex;
            justify-content:space-between;
            font-size:16px;
            font-weight:bold;
          "
        >
          <div>
            Customer Signature
          </div>

          <div>
            Checked By
          </div>

          <div>
            Authorized Signatory
          </div>
        </div>

      </div>

      <style>

        .label{
          border:1px solid #8c8c8c;
          padding:10px;
          font-weight:bold;
          width:20%;
        }

        .value{
          border:1px solid #8c8c8c;
          padding:10px;
          color:#000;
          width:30%;
        }

        .th-style{
          border:2px solid #8c8c8c;
          padding:12px;
          text-align:center;
        }

        .td-center{
          border:1px solid #8c8c8c;
          padding:12px;
          text-align:center;
          color:#000;
        }

        .td-right{
          border:1px solid #8c8c8c;
          padding:12px;
          text-align:right;
          color:#000;
        }

        tbody td{
          border:1px solid #8c8c8c;
          padding:12px;
          color:#000;
        }

        .empty-row{
          height:45px;
          border:1px solid #8c8c8c;
        }

        .total-label{
          border-bottom:1px solid #8c8c8c;
          padding:12px;
          font-weight:bold;
        }

        .total-value{
          border-bottom:1px solid #8c8c8c;
          padding:12px;
          text-align:right;
        }

      </style>
    `;

    document.body.appendChild(invoice);

    // ==========================================
    // CONVERT TO PDF
    // ==========================================

    const canvas = await html2canvas(invoice, {
      scale: 2,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = 210;

    const pdfHeight = 297;

    pdf.addImage(
      imgData,
      "PNG",
      0,
      0,
      pdfWidth,
      pdfHeight
    );

    pdf.save(
      `Invoice-${viewData.bookingId}.pdf`
    );

    document.body.removeChild(invoice);

  } catch (error) {
    console.error("Invoice Error:", error);
  }
};

export default InvoiceDownload;